"use strict";
/**
 * 类似于pipeline自由组合函数并管道式  自左向右 顺序执行
 * 分为两种，均支持异步调用
 * composeNext 拦截式递推进行，next执行会依据上一步返回值，如无返回/false，则终止执行
 * composeAll 则根据第一个入参，依次管道式执行，无拦截
 * callback为每次迭代方法回调
 */
Object.defineProperty(exports, "__esModule", { value: true });
function composeBase(middlewares, ctx, type, callback) {
    if (ctx === void 0) { ctx = null; }
    if (type === void 0) { type = 0; }
    if (!middlewares.length)
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Promise.resolve(args);
        };
    var init = middlewares.shift() || new Function();
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return middlewares.reduce(function (a, b) {
            return a &&
                a
                    .then(function (res) {
                    // composeNext模式,且上一步返回false/undefined
                    if (type && !res)
                        return;
                    callback && callback(res);
                    return b.apply(ctx, typeof args[0] === typeof res ? [res] : args);
                    // 优先用上一步返回参数(前提是两者类型相同)，否则使用原始参数
                })
                    .catch(function (e) { return console.error(e); });
        }, Promise.resolve(init.apply(ctx, args)));
    };
}
var compose = {
    composeNext: function (middlewares, ctx, callback) {
        if (ctx === void 0) { ctx = null; }
        return composeBase(middlewares, ctx, 1, callback);
    },
    composeAll: function (middlewares, ctx, callback) {
        if (ctx === void 0) { ctx = null; }
        return composeBase(middlewares, ctx, 0, callback);
    }
};
exports.default = compose;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/shared-utils/dist/compose/index.js
// module id = 16hq
// module chunks = 1